<template>
  <div class="step-title" :class="{
    'step-title--smaller': smaller,
    'step-title--little': little
  }">
    <slot />
    <span :style="stepStyle" v-if="step">
      <span>{{ $t('checkout.step') }}</span> {{step}}:
    </span>
    <span>{{ title }}</span>
  </div>
</template>

<script>
export default {
  name: "StepTitle",
  props: {
    title: {
      type: String,
      required: true
    },
    step: {
      type: Number,
      default: null
    },
    smaller: {
      type: Boolean,
      required: false,
      default: false
    },
    little: {
      type: Boolean,
      required: false,
      default: false
    },
    stepColor: {
      type: String,
      required: false,
      default: 'inherit'
    }
  },
  computed: {
    stepStyle(){
      return {
        color: this.stepColor
      }
    }
  }
}
</script>

<style scoped lang="scss">
.step-title{
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 8px;
  &--smaller{
    font-size: 18px;
    line-height: 20px;
  }
  &--little{
    font-size: 16px;
  }
}
</style>